// Charge report monthly
import { API_BASE } from "../../config";
import { useEffect, useState } from "react";
import SummaryCard from "../../components/Air/Arrearsreport/month/Card"
import DataSelector from "../../components/Air/Arrearsreport/month/DataSelector";
import AdminLayout from "../../layout/AdminLayout"
import axios from "axios";

const ArrearsByMonth = () =>{

    const [data,setData] = useState(null)
 
    const handleData = async () =>{
        try {
            const res = await axios.get(`${API_BASE}/api/air-client/month/current`)
             setData(res.data.clients);
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(()=>{
        handleData();
    },[])

    return(
        <AdminLayout>
                 <div className="my-5 flex justify-center items-center">
                    {data && <SummaryCard data={data}/>}
                 </div>
                 <div>
                     {data && <DataSelector data={data}/>}
                 </div>
        </AdminLayout>
    );
}
export default ArrearsByMonth;
